export class BaoScrollable extends window.BAO.CustomElement() {
  static get styles () {
    return `
      --Shadow_Size: 20px;

      :host {
        display: block;

        overflow-y: auto;
        -webkit-overflow-scrolling: touch;
      }

      :host::before,
      :host::after {
        content: '';

        position: sticky;
        z-index: 2;
        inset-inline-start: 0;

        display: block;
        block-size: 0;
        inline-size: 100%;

        pointer-events: none;
      }

      :host::before {
        top: calc(var(--Shadow_Size, 20px) * -1);
      }
      :host([data-top-shadow-is-active='true'])::before {
        box-shadow: 0 calc(var(--Shadow_Size, 20px) * -1) var(--Shadow_Size, 20px) var(--Shadow_Size, 20px) rgba(0, 0, 0, 0.15);
      }

      :host::after {
        bottom: calc(var(--Shadow_Size, 20px) * -1);
      }
      :host([data-bottom-shadow-is-active='true'])::after {
        box-shadow: 0 calc(var(--Shadow_Size, 20px)) var(--Shadow_Size, 20px) var(--Shadow_Size, 20px) rgba(0, 0, 0, 0.15);
      }
    `
  }

  isTicking = false
  lastKnownY = 0

  constructor () {
    super()

    this.updateEl = this.updateEl.bind(this)
  }

  connectedCallback () {
    super.connectedCallback()

    this.updateEl()
  }

  setupListeners () {
    super.setupListeners()

    this.listeners.add(this, 'scroll', this.onScroll.bind(this))
  }

  /**
   * @param {Event} e
   */
  onScroll (e) {
    this.lastKnownY = Math.ceil(e.target.scrollTop)

    this.requestTick()
  }

  requestTick () {
    if (!this.isTicking) requestAnimationFrame(this.updateEl)

    this.isTicking = true
  }

  updateEl () {
    this.isTicking = false

    this.topShadowIsActive = this.lastKnownY > 0
    this.bottomShadowIsActive =
      this.lastKnownY >= 0 &&
      !this.hasHitTheBottom &&
      this.scrollHeight > this.offsetHeight
  }

  get hasHitTheBottom () {
    return this.lastKnownY >= this.scrollHeight - this.offsetHeight
  }

  get bottomShadowIsActive () {
    return this.dataset.bottomShadowIsActive === 'true'
  }

  set bottomShadowIsActive (val) {
    this.dataset.bottomShadowIsActive = val.toString()
  }

  get topShadowIsActive () {
    return this.dataset.topShadowIsActive === 'true'
  }

  set topShadowIsActive (val) {
    this.dataset.topShadowIsActive = val.toString()
  }
}

if (!customElements.get('bao-scrollable')) {
  customElements.define('bao-scrollable', BaoScrollable)
}
